import { useEffect, useState } from 'react';
import Button from 'components/Button';
import { VersionCheckerContainer } from './styles';

const VersionChecker = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const currentVersion = document.querySelector('meta[name="app-version"]')?.content;

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json?t=' + Date.now())
          .then(response => {
            // Check for HTTP errors
            if (!response.ok) {
              return response.text().then(html => {
                throw new Error(`Server error: ${response.status}. Response: ${html}`);
              });
            }
            
            // Check if response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType?.includes("application/json")) {
              return response.text().then(html => {
                throw new Error(`Expected JSON, got ${contentType}. Response: ${html}`);
              });
            }
            
            return response.json(); // Safe to parse
          });
        if (Number(res?.version) !== Number(currentVersion)) {
          setUpdateAvailable(true);
        } else {
          setUpdateAvailable(false);
        }
      } catch (e) {
        console.error('Version check failed:', e);
      }
    };

    // Check every 5 minutes
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    checkVersion(); // Initial check

    return () => clearInterval(interval);
  }, [currentVersion]);

  if (!updateAvailable) return null;

  return (
    <VersionCheckerContainer>
      <div className='text'>A new version is available!</div>
      <Button
        onClick={() => window.location.reload()}
      >
        Update Now
      </Button>
    </VersionCheckerContainer>
  );
};

export default VersionChecker; 